/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export { SectionPage } from "../components/pages/section";
export { TagPage } from "../components/pages/tag";
export { SearchPage } from "../components/pages/search-page/search-page";
export { CatalogPage } from "../components/pages/catalog";
export { MagazineIssuesPage } from "../components/pages/magazine-issues";

export { NotFoundPage } from "../components/pages/not-found";
export { AuthorPage } from "../components/pages/author-page";
export { CollectionPage } from "../components/pages/collection-page";
export { AuthorsPage } from "../components/pages/authors-page";
